import React from 'react'

const Loader = ({style, className, loaderStyle,zIndex = "100000"}) => {
    return (
        <div
            className={`position-absolute w-100 bg-white ${className}`}
            style={{...style, zIndex: zIndex, height: "70px"}}
        >
            <div className="loader bg-white" style={{...loaderStyle}}></div>
        </div>
    )
};

export default Loader;